<template>
  <div>
    <Advice v-if="isLoading" img="pencil" priority="low-gray">
      <p>
        検索ユーザーが求めている可能性がある見出しを考えています<span
          class="c-loading-dots"
        ></span>
      </p>
    </Advice>
    <template v-else>
      <Advice img="pencil" priority="low-gray">
        <p v-if="isError">
          <span class="c-text--prewrap">{{ errorMessage }}</span>
        </p>
        <div v-else class="c-text--free">
          <p>
            検索ユーザーは下記のような内容を求めている可能性があると考えられます。<br /><span
              class="c-text--bold"
            >
              上位表示ページにはない独自の情報を追加する際のヒント</span
            >としてください。
          </p>
          <p>
            <span class="c-text--prewrap">{{ aiHeadingsText }}</span>
          </p>
        </div>
      </Advice>
    </template>
  </div>
</template>

<script>
import Advice from '@/components/Advice';
import axios from 'axios';

export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    keyword: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  components: {
    Advice
  },
  data() {
    return {
      aiHeadingsText: '',
      errorMessage: '',
      isError: false,
      isLoading: true
    };
  },
  created() {
    this.fetchAiHeadings();
  },
  methods: {
    fetchAiHeadings() {
      const params = {
        keyword: this.keyword,
        token: this.token
      };
      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}/beta/projects/${this.project.id}/header-proposal`,
          params,
          {
            headers: {
              Authorization: `Bearer ${this.auth.idToken}`,
              'X-From': location.href
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.aiHeadingsText = response.data.content;
          } else {
            this.isError = true;
            this.errorMessage =
              '調査したキーワードはChat API(GPT-3.5)のポリシーに反する内容だったため、AIからの回答を受け取れませんでした。\n上位ページのタイトル・ディスクリプション・見出しテキストなどを参考に、画面右「見出し構成案」をご検討ください。';
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isError = true;
          this.isLoading = false;
          this.errorMessage =
            '申し訳ございません。問題が発生したため、AIからの回答を受け取れませんでした。\n上位ページのタイトル・ディスクリプション・見出しテキストなどを参考に、画面右「見出し構成案」をご検討ください。';
        })
        .finally(() => {
          this.$emit('fetched');
        });
    }
  }
};
</script>
